import { AlertRow } from './alert-message/alert-row';
import { Observable, Subscription } from 'rxjs';
import { AlertMessageService } from './alert-message/alert-message.service';
import { AlertMessage } from './alert-message/alert-message';
import { Output, Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';

import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],

    animations: [
        trigger('messageState', [
            state('inactive', style({
                backgroundColor: '#eee',
                transform: 'scale(1)'
            })),
            state('active', style({
                backgroundColor: '#cfd8dc',
                transform: 'scale(1.1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
            transition('active => inactive', animate('100ms ease-out'))
        ])
    ]
})
export class AlertComponent implements OnInit, OnDestroy {
    constructor() {
    }

    ngOnInit() {
    }

    ngOnDestroy() {

    }
    filterFunction(rows: AlertRow[]): AlertRow[] {
        return rows
            .sort((row1: AlertRow, row2: AlertRow) => {
                return row1.expectedTimeMoment.diff(row2.expectedTimeMoment, 'minutes');
            });
    }
}
